export default function Consent() {
  return (
    <div data-testid="consent-page">
      <section className="bg-navy text-white noise-overlay py-20 md:py-28">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-mono text-bronze text-sm mb-4 tracking-wider uppercase">Communications</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold">SMS &amp; Email Consent Policy</h1>
        </div>
      </section>
      <section className="bg-white py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 font-body text-gray-700 space-y-6">
          <h2 className="font-heading text-2xl text-navy">Consent to Contact</h2>
          <p>By submitting a form on this website and checking the consent box, you agree to receive service-related emails, phone calls, and text messages (SMS) from DA TAXGUY &amp; ASSOCIATES regarding your inquiry, appointments, and account.</p>
          <h2 className="font-heading text-2xl text-navy">Message Frequency &amp; Rates</h2>
          <p>Message frequency varies based on your interactions with us. Message and data rates may apply depending on your mobile carrier and plan.</p>
          <h2 className="font-heading text-2xl text-navy">Opting Out</h2>
          <p>You may opt out of text messages at any time by replying <strong>STOP</strong>. You may unsubscribe from emails using the unsubscribe link in any email. To opt out of phone calls, simply let us know during any call or email <a href="mailto:INFO@DATAXGUY.COM" className="text-bronze underline">INFO@DATAXGUY.COM</a>.</p>
          <h2 className="font-heading text-2xl text-navy">Your Privacy</h2>
          <p>We never sell your information. We do not send sensitive taxpayer data through general messaging or automation tools. Please review our <a href="/privacy" className="text-bronze underline">Privacy Policy</a> for details on how we handle your information.</p>
        </div>
      </section>
    </div>
  );
}
